



















































































import Vue from "vue";
export default Vue.extend({
  name: "Hello",
  components: {},
  props: {
    gridArea: String
  },
  data: () => {
    return {
      showBio: false
    };
  },
  methods: {
    toggleBio: function() {
      this.showBio = !this.showBio;
    }
  }
});
